import React from 'react';

const ReportGrid = ({ children }) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
        }}>
            {children}
        </div>
    );
};

export default ReportGrid;
